import { useQuery } from '@tanstack/react-query';
import { getEscapedIssuesDetail } from '../services/AnalyticReportsService';
export default function useEscapedIssuesDetail(filters, issueType, enabled, page = 1, perPage = 10, technicianIds = [], buildingIds = [], sortBy = null, sortDirection = undefined) {
    return useQuery([
        'escapedIssuesDetail',
        filters.values.dateRange,
        issueType,
        page,
        perPage,
        technicianIds,
        buildingIds,
        sortBy,
        sortDirection
    ], () => getEscapedIssuesDetail(filters, issueType, page, perPage, technicianIds, buildingIds, sortBy, sortDirection), {
        staleTime: 5 * 60 * 1000,
        cacheTime: 30 * 60 * 1000,
        enabled,
        keepPreviousData: true
    });
}
